<template>
    <div class="chart clear">
        <div class="empty text-danger" v-if="!loading && chartData.columns.length === 0">{{t_empty}}</div>
        <div id="chart-wrapper" class="col-md-7 clear">
            <div id="chart"></div>
        </div>
        <div class="col-md-5 legend scrollBox"></div>
    </div>
</template>

<script>
    export default {
        props: {
            chartData: Object,
            loading: Boolean
        },
        data() {
            return {
                t_empty: Lang.langGet("No reports found that match filters"),
                t_h: Lang.langGet("h"),
                t_m: Lang.langGet("m"),
                t_s: Lang.langGet("s"),
                chart: null,
                size: 600,
            }
        },
        methods: {
            initChart () {
                if (typeof Event.reportingChart !== 'undefined') {
                    Event.reportingChart.destroy();
                }
                // http://codepen.io/lucusc/pen/GZXBxX
                Event.reportingChart = c3.generate({
                    size: {
                        height: this.size,
                        width: this.size
                    },
                    data: {
                        columns: this.chartData.columns,
                        type: 'pie',
                        colors: this.chartData.colors
                    },
                    oninit: function () {
                        this.meetsArcLabelThreshold = function (ratio) {
                            return Math.round(1000*ratio)/10 >= 2.5;
                        };
                    },
                    legend: {
                        show: false
                    },
                    tooltip: {
                        format: {
                            value: (value, ratio) => {
                                let percentFormat = d3.format('.1%');
                                let h = Math.floor(value / 3600);
                                let tmpM = value % 3600;
                                let m = Math.floor(tmpM / 60);
                                let s = tmpM % 60;
                                let duration = '';

                                if (h > 0) {
                                    duration = duration + h + this.t_h + ' ';
                                }

                                if (m > 0 || h > 0) {
                                    duration = duration + m + this.t_m + ' ';
                                }


                                duration = duration + s + this.t_s;


                                return duration + ' (' + percentFormat(ratio) + ')';
                            }
                        }
                    },
                });
            }
        },
        mounted() {
            this.size = document.getElementById('chart-wrapper').offsetWidth;

            if (this.size > 600) {
                this.size = 600;
            }

            this.initChart();
        },
        watch: {
            chartData: {
                handler: function (newVal, oldVal) {
                    if (newVal.columns.length > 0) {
                        $('.chart #chart, .chart .legend').removeClass('hidden');
                    } else {
                        $('.chart #chart, .chart .legend').addClass('hidden');
                    }
                    $('.chart #chart, .chart .legend').height(this.size);

                    Event.reportingChart.load({
                        columns: newVal.columns,
                        colors: newVal.colors,
                        unload: true
                    });

                    let sum_duration = 0;
                    newVal.columns.map((column) => {
                        sum_duration = sum_duration + (column[1] ?? 0);
                    })

                    d3.select('.legend')
                        .html('')
                        .insert('ul').attr('class', 'clearfix')
                        .selectAll('span')
                        .data(newVal.columnnames)
                        .enter().append('li').attr('class', 'col-xs-12')
                        .append('div').attr('class', 'element')
                        .attr('data-id', function (id) {
                            return id;
                        })
                        .html((id) => {
                            let index = newVal.columnnames.indexOf(id);
                            let htmlString = '<span class="description"> ' + id;
                            let comment = '';
                            let duration = '';
                            let percentage = '';

                            if (newVal.comments[id]) {
                                comment = ', ' + newVal.comments[id];
                            }

                            if (newVal.columns[index][1]) {
                                let d = newVal.columns[index][1];
                                let h = Math.floor(d / 3600);
                                let tmpM = d % 3600;
                                let m = Math.floor(tmpM / 60);
                                let s = tmpM % 60;

                                duration = ', ';

                                if (h > 0) {
                                    duration = duration + h + this.t_h + ' ';
                                }

                                if (m > 0 || h > 0) {
                                    duration = duration + m + this.t_m + ' ';
                                }

                                duration = duration + s + this.t_s;

                                percentage = (Math.round(1000 * d / sum_duration) / 10) + '%, ';
                            }

                            htmlString = htmlString.concat(
                                '<br />(',
                                percentage,
                                newVal.data[id]['repeats'] + 'x',
                                duration,
                                comment,
                                ')'
                            );

                            htmlString = htmlString + '</span>';
                            return htmlString;
                        })
                        .on('mouseover', function (id) {
                            Event.reportingChart.focus(id);
                        })
                        .on('mouseout', function (id) {
                            Event.reportingChart.revert();
                        })
                        .insert('span', ':first-child')
                        .attr('class', 'icon')
                        .each(function (id) {
                            d3.select(this).style('background-color', Event.reportingChart.color(id));
                        })
                        .html(function (id) {
                            let file = 'file';
                            switch (newVal.data[id]['type']) {
                                case 'picture':
                                    file = 'picture';
                                    break;
                                case 'video':
                                    file = 'video';
                                    break;
                                case 'pdf':
                                    file = 'pdf';
                                    break;
                                case 'ppt':
                                    file = 'ppt';
                                    break;
                                case 'widget':
                                    file = 'widget-compact';
                                    break;
                                case 'web':
                                    file = 'web';
                                    break;
                            }

                            return '<i class="eicon eicon-' + file + ' eicon-color-white"></i>'
                        });
                },
                deep: true
            }
        }
    }
</script>
